import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const SalesHomeLazy = lazy(() => import("./SalesHome").then((module) => ({ default: module.SalesHome })));

export const SalesHomeAsync = () => (
  <Suspense fallback={<LoadingIndicatorFullPage open />}>
    <SalesHomeLazy />
  </Suspense>
);
